// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__TPaDS","skeleton-progress":"Skeleton_skeleton-progress__JIN6i"};